import React from "react";
import styles from "./Softwares.module.css";
import Software from "./Software";

import SeeRouteImg from "../../../assets/images/Softwares/SeeRoute.png";
import SeeRouteImg1 from "../../../assets/images/Softwares/SeeRoute1.png";
import SeeRouteImg2 from "../../../assets/images/Softwares/SeeRoute2.png";
import Iot from "../../../assets/images/Softwares/IOT.jpeg";
import Iot1 from "../../../assets/images/Softwares/IOT1.jpeg";
import Iot2 from "../../../assets/images/Softwares/IOT2.jpeg";
import Raahyab from "../../../assets/images/Softwares/Raahyab.png";
import Raahyab2 from "../../../assets/images/Softwares/Raahyab2.png";
import Raahyab3 from "../../../assets/images/Softwares/Raahyab3.png";

function Softwares() {
  const softwares = [
    {
      title: "راهیاب",
      url: "http://www.raahyab.com",
      images: [Raahyab, Raahyab2, Raahyab3],
      apkDownloadLink: "/Files/RaahyabManager-v1.0.0.apk",
      desc: `راهیاب یک نرم‌افزار پیشرفته مدیریت و ردیابی ناوگان است که با ردیابی لحظه‌ای، ارائه گزارش‌های مسیر و تحلیل داده‌های حرکتی، به کنترل، بهینه‌سازی و افزایش بهره‌وری ناوگان کمک می‌کند. این نرم‌افزار با رابط کاربری مدرن و سازگار، پشتیبانی از دستگاه‌های GPS متنوع و هشدارهای هوشمند، امکان مدیریت ورود و خروج، شناسایی تخلفات رانندگی و بهینه‌سازی مصرف سوخت را فراهم می‌کند. راهیاب انتخابی ایده‌آل برای حمل‌ونقل، لجستیک، پخش و مدیریت ناوگان‌های صنعتی است.`,
      features: [
        {
          title: "مدیریت و ردیابی ناوگان در لحظه",
          description: [
            "مشاهده موقعیت لحظه‌ای وسایل نقلیه روی نقشه و نظارت بر عملکرد آنها. مناسب برای شرکت‌های حمل‌ونقل، لجستیک و خدمات شهری",
          ],
        },
        {
          title: "گزارش‌گیری جامع از مسیرها و فعالیت‌های ناوگان",
          description: [
            "ارائه گزارش‌های دقیق از مسیرهای پیموده‌شده، توقف‌ها، سرعت حرکت و سایر داده‌های ناوگان برای تحلیل و بهینه‌سازی عملکرد",
          ],
        },
        {
          title: "رابط کاربری مدرن و سازگار",
          description: [
            "طراحی کاربرپسند با قابلیت استفاده آسان روی دسکتاپ و موبایل. تجربه‌ای روان و بهینه برای کاربران با هر سطح مهارتی",
          ],
        },
        {
          title: "مدیریت هشدارها و اعلان‌های هوشمند",
          description: [
            "امکان تنظیم هشدارهای خودکار برای تخلفات رانندگی، ورود و خروج از مناطق مشخص‌شده و سایر رخدادهای مهم",
          ],
        },
        {
          title: "کنترل از راه دور وسایل نقلیه",
          description: [
            "امکان خاموش کردن خودرو از راه دور، قفل کردن درب‌ها و اعمال تنظیمات امنیتی برای مدیریت بهتر ناوگان",
          ],
        },
        {
          title: "سازگاری با انواع دستگاه‌های ردیاب GPS",
          description: [
            "پشتیبانی از طیف وسیعی از دستگاه‌های GPS از برندهای مختلف برای افزایش انعطاف‌پذیری در مدیریت ناوگان",
          ],
        },
        {
          title: "تحلیل داده‌ها با هوش مصنوعی",
          description: [
            "تحلیل رفتار رانندگان، پیش‌بینی الگوهای حرکتی و ارائه پیشنهادات برای بهینه‌سازی مصرف سوخت و کاهش هزینه‌ها",
          ],
        },
        {
          title: "مدیریت کاربران و سطح دسترسی‌ها",
          description: [
            "ایجاد حساب‌های کاربری متعدد با سطوح دسترسی مختلف برای بهبود امنیت و کنترل داده‌ها",
          ],
        },
      ],
      usages: [
        {
          industry: "مدیریت ناوگان حمل‌ونقل",
          usage: [
            "ردیابی وسایل نقلیه، تحلیل عملکرد رانندگان و بهینه‌سازی مصرف سوخت",
          ],
        },
        {
          industry: "شرکت‌های پخش و لجستیک",
          usage: ["کنترل دقیق مسیرهای ارسال، برنامه‌ریزی تحویل و کاهش تأخیرها"],
        },
        {
          industry: "سازمان‌های خدمات شهری",
          usage: [
            "مدیریت ناوگان خدماتی مانند ماشین‌آلات شهرداری، خودروهای امدادی و نظافتی",
          ],
        },
        {
          industry: "حمل‌ونقل عمومی",
          usage: [
            "پایش حرکت اتوبوس‌ها و تاکسی‌ها، بهبود زمان‌بندی سفرها و افزایش کیفیت خدمات",
          ],
        },
        {
          industry: "شرکت‌های امنیتی و حفاظتی",
          usage: [
            "نظارت بر خودروهای گشت، مدیریت رویدادهای اضطراری و افزایش امنیت ناوگان",
          ],
        },
        {
          industry: "بخش صنعتی و معدنی",
          usage: [
            "ردیابی و کنترل ماشین‌آلات سنگین در معادن و پروژه‌های عمرانی",
          ],
        },
      ],
    },
    {
      title: "SeeRoute",
      url: "http://www.SeeRoute.ir",
      images: [SeeRouteImg, SeeRouteImg1, SeeRouteImg2],
      desc: "نرم‌افزار Seerote، محصولی از شرکت مهندسی توسعه فناوری نیکان، یک سیستم پیشرفته مدیریت ناوگان است که امکانات گسترده‌ای برای نظارت، کنترل و بهینه‌سازی عملکرد وسایل نقلیه ارائه می‌دهد. این نرم‌افزار با ردیابی لحظه‌ای خودروها، ارائه گزارشات مسیر دقیق و نمایش جزئیات عملکرد دستگاه‌ها، به مدیران ناوگان کمک می‌کند تا بهره‌وری و ایمنی وسایل نقلیه را به حداکثر برسانند. یکی از قابلیت‌های کلیدی Seerote، پشتیبانی از دوربین‌های داخل کابین و فناوری DualCam است که امکان ثبت و مشاهده حوادث رانندگی، نظارت تصویری زنده و افزایش امنیت رانندگان و بار را فراهم می‌کند. با رابط کاربری پیشرفته، گزارش‌گیری دقیق  و پشتیبانی از دستگاه‌های ردیاب تلتونیکا یک راهکار ایده‌آل برای مدیریت ناوگان‌های حمل‌ونقل، لجستیک، خدماتی و صنعتی محسوب می‌شود.",
      features: [
        {
          title: "مدیریت و ردیابی ناوگان در لحظه",
          description: [
            "مشاهده موقعیت لحظه‌ای وسایل نقلیه روی نقشه و نظارت بر عملکرد آنها. مناسب برای شرکت‌های حمل‌ونقل، لجستیک و خدمات شهری",
          ],
        },
        {
          title: "گزارش‌گیری دقیق از مسیرها و عملکرد ناوگان",
          description: [
            "ارائه گزارشات کامل از مسیرهای طی‌شده، توقف‌ها و میزان مصرف سوخت برای تحلیل عملکرد ناوگان",
          ],
        },
        {
          title: "نظارت تصویری زنده و ثبت حوادث با فناوری DualCam",
          description: [
            "پشتیبانی از دوربین‌های داخل کابین و ثبت ویدئوی رویدادهای مهم. افزایش امنیت رانندگان و بهبود عملکرد ناوگان",
          ],
        },
        {
          title: "مدیریت هوشمند هشدارها و اعلان‌ها",
          description: [
            "ارسال هشدار در صورت وقوع رویدادهای مهم مانند تصادف، ترمز ناگهانی یا ورود غیرمجاز به مناطق مشخص‌شده",
          ],
        },
        {
          title: "امکان کنترل از راه دور تجهیزات ناوگان",
          description: [
            "خاموش و روشن کردن وسایل نقلیه از راه دور، قفل کردن درب‌ها و تنظیم پارامترهای مختلف برای افزایش امنیت",
          ],
        },
        {
          title: "پشتیبانی از دستگاه‌های ردیاب تلتونیکا و سایر برندهای معتبر",
          description: [
            "سازگاری با انواع GPS Trackerها و سخت‌افزارهای مدیریت ناوگان، شامل محصولات برند Teltonika",
          ],
        },
        {
          title: "تحلیل داده‌ها با هوش مصنوعی و یادگیری ماشین",
          description: [
            "بررسی و تحلیل داده‌های رفتاری رانندگان، پیش‌بینی خرابی خودروها و بهینه‌سازی مصرف سوخت",
          ],
        },
        {
          title: "مدیریت کاربران و دسترسی‌ها",
          description: [
            "ایجاد حساب‌های کاربری مختلف با سطوح دسترسی سفارشی برای افزایش امنیت داده‌ها",
          ],
        },
      ],

      usages: [
        {
          industry: "مدیریت ناوگان حمل‌ونقل",
          usage: [
            "ردیابی وسایل نقلیه، نظارت بر عملکرد رانندگان و کاهش هزینه‌های عملیاتی",
          ],
        },
        {
          industry: "شرکت‌های پخش و لجستیک",
          usage: [
            "کنترل دقیق مسیرهای ارسال، زمان‌بندی تحویل و بهینه‌سازی مصرف سوخت",
          ],
        },
        {
          industry: "سازمان‌های خدمات شهری",
          usage: [
            "مدیریت خودروهای خدماتی مانند ماشین‌آلات شهرداری و ناوگان امدادی",
          ],
        },
        {
          industry: "حمل‌ونقل عمومی",
          usage: [
            "پایش مسیر حرکت اتوبوس‌ها، تاکسی‌ها و کنترل کیفیت خدمات ناوگان عمومی",
          ],
        },
        {
          industry: "شرکت‌های امنیتی و حفاظتی",
          usage: [
            "نظارت بر خودروهای گشت، مدیریت رویدادهای اضطراری و افزایش امنیت ناوگان",
          ],
        },
        {
          industry: "بخش صنعتی و معدنی",
          usage: [
            "ردیابی و کنترل ماشین‌آلات سنگین در معادن و پروژه‌های عمرانی",
          ],
        },
      ],
    },
    {
      title: "SeeThings",
      url: "http://www.SeeThings.ir",
      images: [Iot, Iot1, Iot2],
      desc: `معرفی نرم‌افزار Seething.ir – محصولی از شرکت توسعه فناوری نوین افزارنیکان
      Seething.ir یک نرم‌افزار اینترنت اشیا (IoT) پیشرفته است که برای کنترل و مانیتورینگ تجهیزات و سنسورهای مختلف در صنایع گوناگون و ساختمان‌های هوشمند طراحی شده است. این سیستم امکان اتصال، مدیریت و تحلیل داده‌های لحظه‌ای را از کنترلرها و سنسورهای متصل به شبکه فراهم می‌کند.`,
      features: [
        {
          title: "مانیتورینگ و نظارت بلادرنگ",
          description: [
            "مشاهده وضعیت لحظه‌ای دستگاه‌ها، سنسورها و تجهیزات. مناسب برای صنایع سردخانه‌ها، نیروگاه‌ها، کارخانه‌ها و مراکز داده",
          ],
        },
        {
          title: "ثبت و ذخیره‌سازی داده‌ها",
          description: [
            "ذخیره‌سازی امن داده‌های سنسورها در پایگاه داده. امکان مشاهده، بررسی و تحلیل داده‌های گذشته",
          ],
        },
        {
          title: "گراف‌های تحلیلی و نمایش داده‌ها",
          description: [
            "داشبورد گرافیکی پیشرفته برای نمایش داده‌ها. نمایش نمودارها و گزارش‌های تحلیلی برای بررسی روند عملکرد تجهیزات",
          ],
        },
        {
          title: "قابلیت کنترل از راه دور",
          description: [
            "امکان تغییر تنظیمات تجهیزات و کنترلرها. تنظیم دمای سردخانه، خاموش/روشن کردن دستگاه‌ها و تنظیم هشدارها",
          ],
        },
        {
          title: "هشدارها و اعلان‌های هوشمند",
          description: [
            "ارسال هشدار در صورت عبور از مقادیر بحرانی مانند افزایش دما یا کاهش فشار. اعلان‌ها از طریق پیامک، ایمیل یا نوتیفیکیشن‌های درون‌سیستمی",
          ],
        },
        {
          title: "اتصال به انواع پروتکل‌ها و سخت‌افزارهای صنعتی",
          description: [
            "پشتیبانی از پروتکل‌های MQTT، Modbus، OPC-UA و BACnet. یکپارچه‌سازی آسان با تجهیزات صنعتی مختلف",
          ],
        },
        {
          title: "مدیریت کاربران و سطح دسترسی‌ها",
          description: [
            "سیستم مدیریت کاربران پیشرفته. امکان تعیین سطوح دسترسی مختلف برای امنیت بیشتر داده‌ها",
          ],
        },
        {
          title: "قابلیت یکپارچه‌سازی با هوش مصنوعی و یادگیری ماشین",
          description: [
            "تحلیل داده‌های جمع‌آوری‌شده با الگوریتم‌های هوش مصنوعی. پیش‌بینی خرابی‌ها، بهینه‌سازی مصرف انرژی و افزایش بهره‌وری",
          ],
        },
      ],
      usages: [
        {
          industry: "ساختمان‌های هوشمند",
          usage: ["کنترل دما، رطوبت، کیفیت هوا و روشنایی"],
        },
        {
          industry: "صنایع غذایی و سردخانه‌ها",
          usage: ["نظارت بر دما و رطوبت برای نگهداری محصولات"],
        },
        {
          industry: "کارخانه‌ها و خطوط تولید",
          usage: ["پایش عملکرد تجهیزات و مصرف انرژی"],
        },
        {
          industry: "مراکز داده و IT",
          usage: ["مانیتورینگ شرایط محیطی مانند دما و رطوبت سرورها"],
        },
        {
          industry: "نیروگاه‌ها و صنایع پتروشیمی",
          usage: ["نظارت بر فشار، دما و شرایط عملیاتی تجهیزات"],
        },
        {
          industry: "گلخانه‌های هوشمند",
          usage: ["مدیریت آبیاری، دما و رطوبت برای بهینه‌سازی رشد گیاهان"],
        },
      ],
    },
  ];
  return (
    <>
      <section className={styles.softwaresSec} id="homePage-Softwares__sec">
        <div className={`${styles.softwaresCont}`}>
          <h2>نرم افزار‌ها</h2>
          <div className={`${styles.softwares}`}>
            {softwares.map((e, index) => {
              return (
                <Software
                  key={index}
                  title={e.title}
                  url={e.url}
                  apkDownloadLink={e.apkDownloadLink}
                  images={e.images}
                  desc={e.desc}
                  features={e.features}
                  usages={e.usages}
                />
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default Softwares;
